<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Electronics & Telecommunication Engineering"
                   :links="[{title:'Home', url:'/'},{title:'PEO,PSO,PO'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="3"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">PEO,PSO,PO</div>
          <Accordion :activeIndex="0">
            <AccordionTab header="Program Educational Objectives (PEOs)">
              <ul class="list-inside">
                <li class="flex justify-start pb-2">
                  <span class="font-semibold mr-2">PEO1:</span>
                  <p>To prepare globally competent graduates having strong fundamentals, domain knowledge, updated
                    with modern technology to provide the effective solutions for engineering problems. </p>
                </li>
                <li class="flex justify-start pb-2">
                  <span class="font-semibold mr-2">PEO2:</span>
                  <p>To prepare the graduates to work as a committed professional with strong professional ethics and
                    values, sense of responsibilities, understanding of legal, safety, health, societal, cultural and
                    environmental issues. </p>
                </li>
                <li class="flex justify-start pb-2">
                  <span class="font-semibold mr-2">PEO3:</span>
                  <p>To prepare committed and motivated graduates with research attitude, lifelong learning,
                    investigative approach, and multidisciplinary thinking.</p>
                </li>
                <li class="flex justify-start pb-2">
                  <span class="font-semibold mr-2">PEO4:</span>
                  <p>To prepare the graduates with strong managerial and communication skills to work effectively as
                    individual as well as in teams.</p>
                </li>
              </ul>
            </AccordionTab>
            <AccordionTab header="Program Specific Outcomes (PSOs)">
              <ul class="list-inside">
                <li class="flex justify-start pb-2">
                  <span class="font-semibold mr-2">PSO1:</span>
                  <p>Professional Skills-The ability to understand, analyze and develop computer programs in the areas
                    related to algorithms, system software, multimedia, web design, big data analytics, and networking
                    for efficient design of computer-based systems of varying.</p>
                </li>
                <li class="flex justify-start pb-2">
                  <span class="font-semibold mr-2">PSO2:</span>
                  <p>Problem-Solving Skills- The ability to apply standard practices and strategies in software
                    project development using open-ended programming environments to deliver a quality product for
                    business success.</p>
                </li>
                <li class="flex justify-start pb-2">
                  <span class="font-semibold mr-2">PSO3:</span>
                  <p>Successful Career and Entrepreneurship- The ability to employ modern computer languages,
                    environments, and platforms in creating innovative career paths to be an entrepreneur, and a zest
                    for higher studies.</p>
                </li>
              </ul>
            </AccordionTab>
            <AccordionTab header="Program Outcomes (POs)">
              <ul class="list-inside">
                <li class="flex flex-col justify-start pb-2">
                  <span class="font-semibold mr-2">PO1 - Engineering Knowledge:</span>
                  <p class="ml-10">Apply the knowledge of mathematics, science, Engineering fundamentals, and an
                    Engineering specialization to the solution of complex Engineering problems.</p>
                </li>
                <li class="flex flex-col justify-start pb-2">
                  <span class="font-semibold mr-2">PO2 - Problem Analysis:</span>
                  <p class="ml-10">Identify, formulate, review research literature, and analyze complex Engineering
                    problems reaching substantiated conclusions using first principles of mathematics natural
                    sciences, and Engineering sciences.</p>
                </li>
                <li class="flex flex-col justify-start pb-2">
                  <span class="font-semibold mr-2">PO3 - Design/Development of Solutions:</span>
                  <p class="ml-10">Design solutions for complex Engineering problems and design system components or
                    processes that meet the specified needs with appropriate consideration for the public health and
                    safety, and the cultural, societal, and Environmental considerations.</p>
                </li>
                <li class="flex flex-col justify-start pb-2">
                  <span class="font-semibold mr-2">PO4 - Conduct Investigations of Complex Problems:</span>
                  <p class="ml-10">Use research-based knowledge and research methods including design of experiments,
                    analysis and interpretation of data, and synthesis of the information to provide valid
                    conclusions.</p>
                </li>
                <li class="flex flex-col justify-start pb-2">
                  <span class="font-semibold mr-2">PO5 - Modern Tool Usage:</span>
                  <p class="ml-10">Create, select, and apply appropriate techniques, resources, and modern Engineering
                    and IT tools including prediction and modeling to complex Engineering activities with an
                    understanding of the limitations.</p>
                </li>
                <li class="flex flex-col justify-start pb-2">
                  <span class="font-semibold mr-2">PO6 - The Engineer and Society:</span>
                  <p class="ml-10">Apply reasoning informed by the contextual knowledge to assess societal, health,
                    safety, legal and cultural issues and the consequent responsibilities relevant to the professional
                    engineering practice.</p>
                </li>
                <li class="flex flex-col justify-start pb-2">
                  <span class="font-semibold mr-2">PO7 - Ethics:</span>
                  <p class="ml-10">Apply ethical principles and commit to professional ethics and responsibilities and
                    norms of the Engineering practice.</p>
                </li>
                <li class="flex flex-col justify-start pb-2">
                  <span class="font-semibold mr-2">PO8 - Communication:</span>
                  <p class="ml-10">Communicate effectively on complex Engineering activities with the Engineering
                    community and with society at large, such as, being able to comprehend and write effective reports
                    and design documentation, make effective presentations, and give and receive clear
                    instructions.</p>
                </li>
                <li class="flex flex-col justify-start pb-2">
                  <span class="font-semibold mr-2">PO9 - Project Management and Finance:</span>
                  <p class="ml-10">Demonstrate knowledge and understanding of the Engineering and management
                    principles and apply these to one’s own work, as a member and leader in a team, to manage projects
                    and in multidisciplinary Environments.</p>
                </li>
              </ul>
            </AccordionTab>
          </Accordion>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/electronics/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';


export default {
  name: "Pos_Peos",
  components: {
    NavbarComponent,
    KeyRecruiters,
    PageHeader,
    Sidebar,
    FooterComponent,
    Accordion,
    AccordionTab
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {div: null}
  }
}
</script>
<style lang="scss" scoped/>
